import {View} from "./View"
export const BusinessDetailsLink =  ()=> {
    return(
        <View />
    )
}